"use client";

import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";

import RainbowButton from "@/components/RainbowButton";

import useAnalytics from "@/hooks/useAnalytics";

import { getApiClient } from "@ide/shared/lib/apiClient";

const CtaInstantConsultation = () => {
  const t = useTranslations();

  const { data: isActive, isSuccess } = useQuery({
    queryKey: ["instant-consultation"],
    queryFn: async () => (await getApiClient().get("/api/instant-consultation"))?.is_active,
    refetchOnWindowFocus: false,
  });

  const { track } = useAnalytics();

  if (isSuccess && isActive) {
    return (
      <RainbowButton
        href="https://whereby.com/max-ide"
        as="a"
        target="_blank"
        className="flex items-center h-8 px-3 rounded-full text-sm"
        onClick={() => track("cta_button_click_instant_consultation")}
      >
        {t("common.header.instant_consultation")}
      </RainbowButton>
    );
  }

  return null;
};

export default CtaInstantConsultation;
